import styles from './ErrorFallback.module.css';

export const ErrorFallback = () => (
  <div className={styles.container}>
    <h1 className={styles.title}>Something went wrong</h1>
    <p className={styles.message}>
      We encountered an unexpected error. Please try refreshing the page.
    </p>
    <button
      className={styles.button}
      onClick={() => window.location.reload()}
      type="button"
    >
      Reload Page
    </button>
  </div>
);
